import React from 'react';

const facilities = [
  "Room Service Is Available In Most Hotels",
  "In The Kitchen",
  "In a Refrigerator",
  "Phone",
  "Sets For Cockery",
  "Backup Power Is 100% Available",
  "Wi-fi Service Is Available For Free At This Hotel",
  "LCTV’s (Liquid Crystal Displays)",
  "Water Contains Minaral Salt",
  "A Linen / Towels Service Is Available",
  "Chef’s Utensils And Accessories",
  "Cab Available With Luxury Features",
  "Parking Is Free For Everyone",
  "The Air Conditioning System",
  "Assistance By Elevator",
  "In Microwaves",
  "Burner And Coffee Maker In One",
  "Cash And All Major Credit Cards Accepted",
];

const ApartmentSection = () => {
  return (
    <>
      {/* Banner Section */}
      <section
        className="page-title"
        style={{
          backgroundImage: 'url(/images/background/3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '120px 0 80px',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <div className="auto-container">
          <h1 style={{ color: '#fff', fontWeight: 'bold' }}>SERVICE APARTMENT</h1>
        </div>
      </section>

      {/* Executive Overview */}
      <section className="services-section" style={{ padding: '60px 15px' }}>
        <div className="auto-container">
          <div className="sec-title text-center">
            <h2 style={{ color: '#008000', fontWeight: 'bold' }}>Rooms With Executive Privileges</h2>
          </div>
          <div className="text text-center mb-5" style={{ maxWidth: 900, margin: '0 auto', fontSize: 16 }}>
            <p>
              Serviced apartments are available in Viman Nagar, Kharadi, Kalyani Nagar, Hinjewadi and Magarpatta for corporate long stays.
              There is a king/twin size bed, attached bathroom with 24/7 hot/cold water, LED TV, Wi-Fi, Daily Housekeeping/Linen Change,
              Common living with sofa seating, dining table, and food and laundry facilities. Viman Nagar Pune Service apartments.
              It is a good alternative to expensive hotels in all areas in Pune.
            </p>
          </div>

          <div className="row clearfix" style={{ display: 'flex', gap: 30, flexWrap: 'wrap' }}>
            <div className="content-column col-md-6" style={{ flex: '1 1 45%' }}>
              <div className="inner-box">
                <h3 style={{ color: '#008000' }}><strong>Hotel Rooms</strong></h3>
                <img src='/images/resource/hotal-room.jpeg' alt='rooms-img'/>
                <p>
                  Serviced apartments in Viman Nagar, Kharadi, Kalyani Nagar, Hinjewadi, Magarpatta. A Queen/King size bed,
                  attached bathroom, sofa seating and dining table complete the bedroom. Wi-Fi, LED TV, daily housekeeping,
                  linen changes, food & laundry. Viman Nagar Pune serviced apartments for long-term stays.
                </p>
              </div>
            </div>

            <div className="content-column col-md-6" style={{ flex: '1 1 45%' }}>
              <div className="inner-box">
                <h3 style={{ color: '#008000' }}><strong>Rooms With A Classic Flair</strong></h3>
                <p>
                  <img src='/images/resource/fair.jpg' alt='rooms-img'/>
                  The bedroom in all serviced apartments is a classic room that offers a comfortable experience with a King size bed,
                  attached bathroom, LED TV, Wi-Fi, Daily Housekeeping/Linen Change, Food & Laundry facilities as well.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2BHK and 3BHK */}
      <section className="services-section" style={{ padding: '30px 15px 60px' }}>
        <div className="auto-container">
          <div className="row clearfix" style={{ display: 'flex', gap: 30, flexWrap: 'wrap' }}>
            <div className="content-column col-md-6" style={{ flex: '1 1 45%' }}>
              <div className="inner-box">
                <h3 style={{ color: '#008000' }}><strong>Apartment with 2 Bedrooms</strong></h3>
                   <img src='/images/resource/apartment.jpg' alt='bedrooms'/>
                <p>

                  Long-stay 2 bedroom service apartments in multiple locations. Fully furnished with kitchen, sofa, dining, Wi-Fi,
                  LED TV, daily housekeeping, and part-time cook options.
                </p>
              </div>
            </div>

            <div className="content-column col-md-6" style={{ flex: '1 1 45%' }}>
              <div className="inner-box">
                <h3 style={{ color: '#008000' }}><strong>Executive Serviced Apartment (3 Bedrooms)</strong></h3>
                 <img src='/images/resource/3apart.jpg' alt='bedrooms-img'/>
                <p>
                  Spacious 3BHK apartments ideal for corporate projects with King/Twin beds, full kitchen, living/dining, LED TV,
                  Wi-Fi, and daily cleaning. Locations: Viman Nagar, Kharadi, etc.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Suites and Cities */}
      <section className="services-section" style={{ padding: '30px 15px 60px' }}>
        <div className="auto-container">
          <h3 style={{ color: '#008000', fontWeight: 'bold', marginBottom: '20px' }}>
            Suites Are Available In This Hotel
          </h3>
          <p>
            Air-conditioned suites with King-sized beds, Wi-Fi, LED TV, daily cleaning, and linen change. Locations: Viman Nagar,
            Kharadi, etc.
          </p>

          <div className="row clearfix" style={{ display: 'flex', gap: 30, flexWrap: 'wrap', marginTop: '30px' }}>
            <div className="content-column col-md-6" style={{ flex: '1 1 45%' }}>
              <div className="inner-box">
                <h4 style={{ color: '#008000' }}><strong>Service Areas</strong></h4>
                <p>Viman Nagar, Kharadi, Kalyani Nagar, Hinjewadi, Magarpatta.</p>
              </div>
            </div>
            <div className="content-column col-md-6" style={{ flex: '1 1 45%' }}>
              <div className="inner-box">
                <h4 style={{ color: '#008000' }}><strong>We Serve These Cities</strong></h4>
                <p>Pune, Mumbai, Nagpur, Nashik, Kolhapur, Aurangabad, Bangalore, Chennai, Hyderabad.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Facilities */}
      <section className="services-section" style={{ padding: '30px 15px 60px', backgroundColor: '#f9f9f9' }}>
        <div className="auto-container">
          <h3 style={{ color: '#008000', fontWeight: 'bold', fontSize: '24px', marginBottom: '30px' }}>
            FACILITIES WITHOUT COMPROMISE
          </h3>
          <ul style={{ listStyle: 'none', padding: 0, fontSize: '16px', lineHeight: '1.8' }}>
            {facilities.map((item, index) => (
              <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                <span style={{ color: '#008000', fontWeight: 'bold' }}>✓</span>
                <span style={{ color: '#222' }}>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default ApartmentSection;



